import React, { Component } from 'react';

import logo from './logo.svg';

import './App.css';
import Clock from 'react-digital-clock';


class App extends Component {

  render() {

    return (

      <div className="App">

        <header className="App-header">

          <label className="App-title">React Digital Clock</label>

        </header>

        <div>

          <div className="row">

              <label><pre><code class="jsx hljs javascript">&lt;Clock /&gt;</code></pre></label>

              <span><Clock/></span>

          </div>

          <div className="row">

              <label><pre><code class="jsx hljs javascript">&lt;Clock


             format= &#123;<span class="hljs-string">'hh-mm'</span>&#125;

              /&gt;</code></pre></label>

              <span><Clock format={'hh-mm'} /></span>

          </div>

           <div className="row">

              <label><pre><code class="jsx hljs javascript">&lt;Clock



             locale= &#123;<span class="hljs-string">'ar-AE'</span>&#125;

              /&gt;</code></pre></label>

              <span><Clock locale={'ar-AE'} /></span>

          </div>

           <div className="row">

              <label><pre><code class="jsx hljs javascript">&lt;Clock



             hour12= &#123;<span class="hljs-string">false</span>&#125;

              /&gt;</code></pre></label>

              <span><Clock hour12={false} /></span>

          </div>

          
        </div>

      </div>

    );

  }

}



export default App;



// WEBPACK FOOTER //
// ./src/App.js